<template>
  <div>
    <div v-if="state === 'loading'"></div>
    <div v-if="state !== 'loading'" class="flex md:justify-center">
      <div id="banner" class="sm:hidden xl:block lg:sticky flex-grow bg-center bg-cover bg-no-repeat"></div>
      <div id="auth" class="sm:w-full md:w-7/12 lg:w-6/12 xl:w-5/12 max-w-2xl min-h-screen">
        <div class="px-10 pt-16 pb-10">
          <a href="https://vettinggateway.com" target="_blank" rel="noopener noreferrer">
            <img id="logo" src="./assets/logo.webp" class="pb-12">
          </a>

          <login v-if="state === 'login'" @success="handleLoginSuccess($event)"
                 @passwordReset="state = 'passwordReset'; username = $event"
                 @forgotPassword="state = 'accountRecovery'"
                 @createAccount="redirectToAccountCreation"
                 @sso="state = 'sso'"></login>

          <sso v-if="state === 'sso'" @cancel="state = 'login'"></sso>

          <mfa-setup v-if="state === 'mfaSetup'" :user="user" @success="handleAuthenticated" @skip="handleAuthenticated"
                     @cancel="logout(true)"></mfa-setup>
          <mfa-challenge v-if="state === 'mfaChallenge'" :user="user" @success="handleAuthenticated($event)"
                         @cancel="logout(true)"></mfa-challenge>
          <password-reset v-if="state === 'passwordReset'" :user="user" :username="username" @success="logout(true)"
                          @cancel="logout(true)"></password-reset>
          <account-recovery v-if="state === 'accountRecovery'" @cancel="logout(true)"
                            @sent="state = 'passwordReset'; username = $event"></account-recovery>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./components/Login";
import MfaSetup from "./components/MfaSetup";
import MfaChallenge from "./components/MfaChallenge";
import PasswordReset from "./components/PasswordReset";
import AccountRecovery from "./components/AccountRecovery";
import {Auth} from "aws-amplify";
import {logout} from "./functions";
import config from "@/config/app"
import Sso from "@/components/SSO";

function postAuthForm({ token, rmtFlag = false, source = null }) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${config.vgw_platform.url}/authenticate`;

  const csrfTokenMeta = document.head.querySelector('meta[name="csrf-token"]');
  if (csrfTokenMeta) {
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = '_token';
    csrfInput.value = csrfTokenMeta.content;
    form.appendChild(csrfInput);
  }

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'token';
  tokenInput.value = token;
  form.appendChild(tokenInput);

  if (rmtFlag) {
    const rmtInput = document.createElement('input');
    rmtInput.type = 'hidden';
    rmtInput.name = 'rmt';
    rmtInput.value = '1';
    form.appendChild(rmtInput);
  }

  if (source) {
    const sourceInput = document.createElement('input');
    sourceInput.type = 'hidden';
    sourceInput.name = 'source';
    sourceInput.value = source;
    form.appendChild(sourceInput);
  }

  document.body.appendChild(form);
  form.submit();
}

export default {
  name: 'App',
  components: {Sso, AccountRecovery, PasswordReset, Login, MfaSetup, MfaChallenge},
  data() {
    return {
      user: false,
      username: '',
      state: 'loading',
      source: null,
    }
  },
  async created() {
    await Auth.signOut()

    const queryParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(queryParams.entries());
    const sourceParam = params['source'];
    if (typeof sourceParam === 'string' && sourceParam.length) {
      this.source = sourceParam
    }

    if (window.location.pathname.indexOf('/logout') === 0) {
      this.logout(true)
      return
    }

    this.state = 'login'
  },
  methods: {
    async handleLoginSuccess(user) {

      this.user = user

      if (this.user.challengeName === 'SOFTWARE_TOKEN_MFA') {

        // todo: if i reset mfa, set it back up again but dont click remeber me - it will still remember me?
        let rm = window.localStorage.getItem(`rm-${user.username}`);
        let rmt = window.localStorage.getItem(`rmt-${user.username}`);

        if (typeof rm === 'string' && typeof rmt === 'string' && new Date(rm).valueOf() > new Date().valueOf()) {
          
          await Auth.signOut();

          postAuthForm({
            token: rmt,
            rmtFlag: true,
            source: this.source,
          });

          return;
        }
      }
      
      this.state = this.user.challengeName === 'SOFTWARE_TOKEN_MFA' ? 'mfaChallenge' : 'mfaSetup'
    },

    handleAuthenticated() {
      Auth.currentAuthenticatedUser().then(user => {
        return this.redirectToApplication(user);
      })
    },

    async logout(redirect) {
      return await logout(redirect)
    },

    async redirectToApplication(user) {

      const authToken = user.signInUserSession.idToken.getJwtToken();

      await this.logout(false);
      await Auth.signOut();
      
      postAuthForm({
        token: authToken,
        source: this.source,
      });

      return true;
    },

    redirectToAccountCreation() {
      window.location.href = `${config.vgw_platform.url}/signup/organisation` + (this.source ? '?source=' + this.source : '')
    }
  }
}

</script>